import { AppSettings } from 'core/AppSettings';
import { useEffect, useState } from 'react';
import { GlobalHotKeys } from 'react-hotkeys';

/**
 * Trigger an error that calls our logging service by holding ALT and typing 500
 */
export const TriggerError = () => {
  const [error, setError] = useState<null | { message: string }>(null);

  useEffect(() => {
    if (!error) return;
    throw new Error(error.message);
  }, [error]);

  if (!AppSettings.isDevelopment && !AppSettings.debug) return null;

  return (
    <GlobalHotKeys
      keyMap={{
        TRIGGER_ERROR: 'alt+5 alt+0 alt+0',
      }}
      handlers={{
        TRIGGER_ERROR: () => {
          /**
           * react-hotkeys catches any errors thrown in handlers,
           * so need to set an error, then throw within a useEffect
           * in order to hit an error boundary
           */
          setError({ message: 'TEST_ERROR_TRIGGERED' });
        },
      }}
    />
  );
};
